export default __webpack_public_path__ + "static/1-1-3-0-3b022aef967129168364ebebeed40d2c.jpg";